import { useQuery } from 'react-query';

import { getDHTClaSettings } from 'RestAPIs/admin';

const useGetTableData = () => {
  const { data, isFetching } = useQuery(
    ['DHTClaSettings', 'list'],
    async () => {
      const { data } = await getDHTClaSettings();
      return data;
    }
  );

  return { data, isFetching };
};

export default useGetTableData;
